import * as React from 'react';
import type { SVGProps } from 'react';
const SvgForwardToInbox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={14}
    fill="none"
    viewBox="0 0 17 14"
    {...props}
  >
    <path
      fill="#999"
      d="M14.5 1.5h-13v9h8V12h-8a1.44 1.44 0 0 1-1.052-.448A1.44 1.44 0 0 1 0 10.5v-9Q0 .896.448.448A1.44 1.44 0 0 1 1.5 0h13q.619 0 1.06.448Q16 .897 16 1.5V7h-1.5zm-13 0v9-3.73.022zM8 5.23l6.5-3.73v1.77l-6.104 3.5a.76.76 0 0 1-.771 0L1.5 3.27V1.5zM14.125 12h-2.376a.73.73 0 0 1-.534-.214.72.72 0 0 1-.215-.532q0-.316.215-.535a.72.72 0 0 1 .534-.219h2.376l-.672-.672a.72.72 0 0 1-.224-.526q0-.302.23-.541a.745.745 0 0 1 1.06.007l1.963 1.964a.72.72 0 0 1 .226.522q0 .296-.229.517l-1.958 1.958a.68.68 0 0 1-.521.219.76.76 0 0 1-.52-.24.73.73 0 0 1 0-1.062z"
    />
  </svg>
);
export default SvgForwardToInbox;
